module.exports = __webpack_public_path__ + "8d99e6573730a1aca16dc2412dedf92d.pdf";